import React, { useState, useEffect } from "react";
import axios from "axios";
import { enqueueSnackbar } from "notistack";

const Contact = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  // State to handle form inputs
  const [full_name, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [industry, setIndustry] = useState("");
  const [message, setMessage] = useState("");

  // State for loading and error handling
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      full_name,
      email,
      phone,
      industry,
      message,
    };

    setLoading(true);
    setError("");

    // Send POST request to the API
    axios
      .post("https://api.datafluent.xyz/api/contact/", formData)
      .then((response) => {
        console.log("Form submitted successfully:", response.data);
        enqueueSnackbar(
          "Your consultation has been successfully booked! We will be in touch soon.",
          { variant: "success", autoHideDuration: 2000 } // 2000ms = 2 seconds
        );

        // Reset form fields after successful submission
        setFullName("");
        setEmail("");
        setPhone("");
        setIndustry("");
        setMessage("");
      })
      .catch((err) => {
        console.error("Error submitting the form:", err);
        setError("Something went wrong. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <section id="center" className="center_o bg-black p_3">
        <div className="container-xl">
          <div className="row center_o1">
            <div className="col-md-12">
              <h2 className="text-white">Contact</h2>
              <h6 className="mb-0 mt-3 col_yell">
                <a className="text-white" href="#">
                  Home
                </a>
                <span className="mx-2 text-muted">/</span> Contact
              </h6>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="p_3">
        <div className="container-xl">
          <div className="row contact_1">
            <div className="col-md-7">
              <div className="contact_1l">
                <h3>Contact Us</h3>
                <p>
                  Have any questions or need assistance? Feel free to reach out
                  to us. Our team is here to help you!
                </p>

                <div className="mt-5">
                  <h4>Bangladesh</h4>
                  <p className="mb-2 ms-3">
                    <i className="fa fa-map-marker me-1 col_yell"></i>
                    Islam Tower, Level 6, 464/H DIT Road, Rampura, Dhaka
                  </p>
                  <p className="mb-2 ms-3">
                    <i className="fa fa-phone me-1 col_yell"></i> +88
                    02-55128812
                  </p>
                  <p className="ms-3">
                    <i className="fa fa-envelope me-1 col_yell"></i>{" "}
                    dfaadmin@datafluent.xyz
                  </p>

                  <h4>Australia</h4>
                  <p className="mb-2 ms-3">
                    <i className="fa fa-map-marker me-1 col_yell"></i>
                    1015A Botany Road, Mascot, NSW 2020, Australia
                  </p>
                  <p className="mb-2 ms-3">
                    <i className="fa fa-phone me-1 col_yell"></i> +61 400 810
                    105
                  </p>
                  <p className="ms-3">
                    <i className="fa fa-envelope me-1 col_yell"></i>{" "}
                    dfaadmin@datafluent.xyz
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-5">
              <div className="contact_1r p-4 rounded-3 bg-black">
                <form onSubmit={handleSubmit}>
                  <input
                    className="form-control bg-white rounded-3 border-0"
                    placeholder="Full Name"
                    type="text"
                    value={full_name}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                  />
                  <input
                    className="form-control bg-white rounded-3 border-0 mt-3"
                    placeholder="Email Address"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <input
                    className="form-control bg-white rounded-3 border-0 mt-3"
                    placeholder="Phone"
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                  <select
                    className="form-select bg-white rounded-3 border-0 mt-3"
                    value={industry}
                    onChange={(e) => setIndustry(e.target.value)}
                    required
                  >
                    <option value="">Industry</option>
                    <option value="Bank">Bank</option>
                    <option value="Insurance">Insurance</option>
                    <option value="IT">IT</option>
                    <option value="Healthcare">Healthcare</option>
                    <option value="Finance">Finance</option>
                    <option value="Travel">Travel</option>
                    <option value="Real Estate">Real Estate</option>
                    <option value="Telecom">Telecom</option>
                    <option value="Manufacturing">Manufacturing</option>
                    <option value="Retail">Retail</option>
                    <option value="Transportation">Transportation</option>
                    <option value="Energy">Energy</option>
                    <option value="Other">Other</option>
                  </select>
                  <textarea
                    className="form-control bg-white rounded-3 border-0 mt-3 form_text"
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>

                  <h6 className="mt-4 mb-0 text-center">
                    <button type="submit" className="button d-block">
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </h6>
                  {error && <div className="text-danger mt-2">{error}</div>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
